import { Group, Text, Anchor } from "@mantine/core";
import type { TextProps } from "@mantine/core";
import { shortHash } from "@/lib/format";
import { CopyButton } from "./CopyButton";

/** Monospace id/hash with copy affordance, optionally shortened. */
export function Mono({
  value,
  short,
  copy = true,
  ...rest
}: { value: string | null | undefined; short?: boolean; copy?: boolean } & TextProps) {
  if (!value) return <Text c="dimmed">—</Text>;
  return (
    <Group gap={4} wrap="nowrap" component="span">
      <Text ff="monospace" size="sm" {...rest}>
        {short ? shortHash(value) : value}
      </Text>
      {copy ? <CopyButton value={value} /> : null}
    </Group>
  );
}

/** External explorer / report link rendered as a shortened mono value. */
export function ExternalMono({
  value,
  href,
  short = true,
}: {
  value: string | null | undefined;
  href: string | null;
  short?: boolean;
}) {
  if (!value) return <Text c="dimmed">—</Text>;
  if (!href) return <Mono value={value} short={short} />;
  return (
    <Group gap={4} wrap="nowrap" component="span">
      <Anchor href={href} target="_blank" rel="noreferrer" ff="monospace" size="sm">
        {short ? shortHash(value) : value}
      </Anchor>
      <CopyButton value={value} />
    </Group>
  );
}
